<template>
  <div id="contact">
    <div class="container">
      <h2 class="title-items">
        Contacto
        <span>Contact</span>
      </h2>
      <form method="POST" action="https://formspree.io/fabriciok@klasea.com">
        <input type="text" id="firstname" name="firstname" placeholder="Nombre | Name..." required />
        <label for="firstname">Nombre <span>Name</span></label>

        <input type="text" id="telephone" name="telephone" placeholder="Teléfono | Telephone..." />
        <label for="telephone">Teléfono <span>Telephone</span></label>

        <input type="email" id="email" name="email" placeholder="Correo | Email..." required />
        <label for="email">Correo <span>Email</span></label>

        <textarea
            id="subject"
            name="subject"
            placeholder="Consulta | Subject.."
            required
        ></textarea>
        <label for="subject">Consulta <span>Subject</span></label>

          <input type="submit" value="Enviar | Submit" />
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactPage",
  computed: {
    email() {
      let email = this.$store.getters.getParameterValueByKey("email");
      return email ? email.value_es : "";
    }
  }
};
</script>

<style lang="scss" scoped>
.title-items {
  color: white;
  margin-top: 0;
}
input[type="text"],
input[type="email"],
input[type="number"],
select,
textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
}
textarea {
    height:200px
}

label {
  padding: 12px;
  display: inline-block;
}
label span {
    color: #aaaaaa;
}

input[type="submit"] {
    display: block;
    margin: auto;
  background-color: #aaa;
  color: black;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

input[type="submit"]:hover {
  background-color: #fff;
}

.container {
  max-width: 1260px;
  margin: auto;
  padding: 20px;
  height: initial;
}

.col-25 {
  float: left;
  width: 25%;
  margin-top: 6px;
}

.col-75 {
  float: left;
  width: 75%;
  margin-top: 6px;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}

/* Responsive layout - when the screen is less than 600px wide, make the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  .col-25,
  .col-75,
  input[type="submit"] {
    width: 100%;
    margin-top: 0;
  }
}
#contact {
  background-color: black;
  padding: 200px 0 50px;
  position: relative;
  p,
  label {
      display: block;
    color: white;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
    text-align: center;
    font-size: 24px;
    line-height: 1.5;
    letter-spacing: 0.02em;
  }
  div p {
    color: #aaa;
  }
  b {
    text-transform: uppercase;
  }
}
@media (max-width: 769px) {
  #contact {
    padding: 210px 0 50px;
  }
}
</style>